<h2 mat-dialog-title>Editar Contrato</h2>

<mat-dialog-content>
  <p><strong>Contract ID:</strong> {{ data.id }}</p>
  <p><strong>Servicio:</strong> {{ data.service }}</p>
  <p><strong>Precio:</strong> {{ data.price }}€</p>
  <p><strong>Estado:</strong> {{ getProcessStatus(data.status) }}</p>

  <!-- <mat-form-field class="full-width" appearance="fill">
    <mat-label>Estado</mat-label>
    <mat-select [(value)]="data.status">
      <mat-option value="en curso">En curso</mat-option>
      <mat-option value="completado">Completado</mat-option>
      <mat-option value="cancelado">Cancelado</mat-option>
    </mat-select>
  </mat-form-field> -->
  
  <!-- PASO 4: SUBIR FORMULARIO Y CUESTIONARIOS GENERADOS -->
  <mat-form-field appearance="fill" class="email-input">
    <mat-label>Price</mat-label>
    <input matInput [(ngModel)]="price" >
  </mat-form-field>

 
  <div class="insurance-progress-card" *ngIf="isCurrentStatus(4)">
  <p class="progress-subtitle">
      Enviar los documentos generados por Omnibus al cliente
  </p>

  <div class="upload-section" *ngIf="!loading">
      <div class="margin-1rem">
          <!-- PASAPORTE -->
          <app-file-upload [fileId]="'formulario'" [pickerLabel]="'📄 Formulario Solicitud:'" [formatsAccepted]="'.pdf,.jpg,.jpeg,.png,.doc,.docx'" (selectedFile)="localSaveFile($event)"></app-file-upload>
          <!-- CARTA DE ACEPTACIÓN -->
          <app-file-upload [fileId]="'cuestionario'" [pickerLabel]="'🏫 Cuestionario ASISA:'" [formatsAccepted]="'.pdf,.jpg,.jpeg,.png,.doc,.docx'" (selectedFile)="localSaveFile($event)"></app-file-upload>
      
      </div>
      
      </div>

  </div>

  <!-- PASO 7: ENVIAR ENLACE DE PAGO Y CORREO DE NOTIFICACION DE APROBADO -->
  <div *ngIf="isCurrentStatus(7)">
      <mat-form-field appearance="outline" class="full-width">
          <mat-label>Enlace de pago:</mat-label>
          <input matInput [(ngModel)]="paymentLink" name="paymentLink" />
      </mat-form-field>
  </div>


  <!-- PASO 9: SUBIR COMPROBANTE EN PDF DEL CLIENTE -->
  <div *ngIf="isCurrentStatus(9)">
    <!-- PASAPORTE -->
    <app-file-upload [fileId]="'comprobante'" [pickerLabel]="'📄 Comprobante cobertura seguro médico:'" [formatsAccepted]="'.pdf,.jpg,.jpeg,.png,.doc,.docx'" (selectedFile)="localSaveFile($event)"></app-file-upload>
  </div>

</mat-dialog-content>

<mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="loading"></mat-spinner>

<mat-dialog-actions align="end" *ngIf="!loading">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>